module.exports = __webpack_public_path__ + "img/shipinghao-c.769cc161.jpeg";